<template>
  <el-submenu index="3" class="menu-item-user" popper-class="menu-item-user-options" :popper-append-to-body="true">
    <template slot="title">{{ $t('iDalgoDefault.myAccount') }}</template>
    <el-menu-item index="3-1" :route="{ path: $route.fullPath }" @click="logout"><svgicon name="clear" class="deconnectIcon"></svgicon>{{ $t('iDalgoDefault.logOut') }}</el-menu-item>
  </el-submenu>
</template>

<script>

export default {
  name: 'iDalgo-Logout',
  data () {
    return {}
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
    }
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/iDalgo-Nav-Menus/iDalgo-Logout.vue